import React, { Component } from "react";

import Typekit from "react-typekit";
import { Route } from "react-router-dom";
import { spring, AnimatedSwitch } from "react-router-transition";

import Header from "components/Layout/Includes/Header";
import Footer from "components/Layout/Includes/Footer";
import Home from "Pages/Home";
import Contact from "Pages/Contact";
import Assortment from "Pages/Assortment";
import About from "Pages/About";
import Vacatures from "Pages/Vacatures";
import VacatureSingle from "Pages/VacatureSingle";
import NotFound from "Pages/NotFound";
import Sustainable from "Pages/Sustainable";
import Blog from "Pages/Blog";
import BlogSingle from "Pages/BlogSingle";

// we need to map the `scale` prop we define below
// to the transform style property
function mapStyles(styles) {
  return {
    // position: styles.foo <= 1 ? 'relative' : 'absolute',
    position: styles.foo <= 1 ? "static" : "absolute",
    width: "100%",
    opacity: styles.opacity,
    // transform: `translateY(${styles.x}px)`
  };
}

// wrap the `spring` helper to use a bouncy config
function bounce(val) {
  return spring(val, {
    stiffness: 200,
    damping: 12,
  });
}
// function opacity(val) {
// 	return spring(val, {
// 		stiffness: 230,
// 		damping: 10
// 	});
// }

// child matches will...
const bounceTransition = {
  // start in a transparent, upscaled state
  atEnter: {
    opacity: 0,
    foo: 0,
    // scale: 1.2,
    x: -24,
  },
  // leave in a transparent, downscaled state
  atLeave: {
    opacity: bounce(0),
    foo: 2,
    // scale: bounce(0.8),
    x: bounce(-24),
  },
  // and rest at an opaque, normally-scaled state
  atActive: {
    opacity: bounce(1),
    foo: 1,
    // scale: bounce(1),
    x: bounce(0),
  },
};

export default class DefaultLayout extends Component {
  render() {
    return [
      <Header key="header" />,
      <Typekit kitId="hvi2awa" key="typekit" />,
      <main className="main" key="main">
        <AnimatedSwitch
          key="switch"
          atEnter={bounceTransition.atEnter}
          atLeave={bounceTransition.atLeave}
          atActive={bounceTransition.atActive}
          mapStyles={mapStyles}
          className="route-wrapper"
        >
          <Route exact path="/" component={Home} key="home" />
          <Route exact path="/contact" component={Contact} key="contact" />
          <Route
            exact
            path="/assortiment"
            component={Assortment}
            key="assortment"
          />
          <Route exact path="/over-fpg" component={About} key="about" />
          <Route
            exact
            path="/vacatures"
            component={Vacatures}
            key="vacatures"
          />
          <Route
            exact
            path="/vacatures/:slug"
            component={VacatureSingle}
            key="blog-single"
          />
          <Route
            exact
            path="/duurzaamheid"
            component={Sustainable}
            key="sustainable"
          />
          <Route exact path="/blog" component={Blog} key="blog" />
          <Route
            exact
            path="/blog/:slug"
            component={BlogSingle}
            key="blog-single"
          />
          <Route path="*" component={NotFound} key="not-found" />
        </AnimatedSwitch>
      </main>,
      <Footer key="footer" />,
    ];
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/DefaultLayout.jsx